import { Outlet } from "react-router-dom";
import Header from "./Dashboard/Header/Header";
import SideNav from "./Dashboard/SideNav/SideNav";
import { useNavigate, useLocation } from "react-router-dom";
import React, { useState } from 'react';


const Admin = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const location = useLocation();
    const isAdministrator = location.pathname.startsWith("/admin/administrator");
    const isRegistration = location.pathname.startsWith("/admin/register")

    const handleToggleClick = () => {
        setIsExpanded(prev => !prev);
      };

    return (
        <>
            {(isAdministrator || isRegistration) ? (<Outlet />) : (<div >
                <Header />
                <div style={{ display: 'flex', minHeight: '100%', paddingTop: '60px' }}>
                    <SideNav isExpanded={isExpanded} onToggle={handleToggleClick} />
                    <div style={{ marginLeft: isExpanded ? '200px' : '60px', flexGrow: 1, transition: 'margin-left 0.3s' }}>
                        <Outlet />
                    </div>
                </div>
            </div>)}
        </>
    )
};

export default Admin;